import React from 'react';
import { Table } from 'react-bootstrap';
import { Bubble } from 'ctia-ui';
import LabResultRow from 'components/labRequest/LabResultRow';

const LabResultList = ({ list }) => {
  if (!list) return null;

  return (
    <div>
      <Bubble>
        You may enter the test results for a request by clicking on the{' '}
        <strong>Request</strong>.
      </Bubble>
      <Table striped condensed hover>
        <thead>
          <tr>
            <th>Request Id</th>
            <th>Manufacturer</th>
            <th>Model Name / Number</th>
            <th>Device Type</th>
            <th>Request Type</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <LabResultRow tableRows={list} />
        </tbody>
      </Table>
    </div>
  );
};

export default LabResultList;



// WEBPACK FOOTER //
// ./src/containers/testResult/LabResultList.js